import { ThemeFontConfiguration } from "../../types/theme";

export const THEME_FONTS: ThemeFontConfiguration = {
  paragraph: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  display: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '30px',
  },
  button: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  headline1: {
    fontSize: '48px',
    fontWeight: 600,
    lineHeight: '48px',
  },
  headline2: {
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '36px',
  },
  headline3: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '35px',
  },
} as const;

//old texts
// export const THEME_FONTS: ThemeFontConfiguration = {
//   paragraph: {
//     fontSize: '20px',
//     fontWeight: 400,
//     lineHeight: '26px',
//   },
//   label: {
//     fontSize: '14px',
//     fontWeight: 400,
//     lineHeight: '20px',
//   },
//   display: {
//     fontSize: '20px',
//     fontWeight: 500,
//     lineHeight: '20px',
//   },
//   button: {
//     fontSize: '16px',
//     fontWeight: 400,
//     lineHeight: '24px',
//   },
//   headline1: {
//     fontSize: '64px',
//     fontWeight: 600,
//     lineHeight: '36px',
//   },
//   headline2: {
//     fontSize: '36px',
//     fontWeight: 600,
//     lineHeight: '36px',
//   },
//   headline3: {
//     fontSize: '32px',
//     fontWeight: 500,
//     lineHeight: '35px',
//   },
// } as const;